import { createContext } from "react";

export const PasswordContext = createContext(null);
